import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Provider } from "react-redux";
import Layout from "./pages/Layout";
// import Users from "./pages/Users";
import store from "./redux/store";

export const darkTheme = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: "#4C1B72",
      light: "#DAD9DC",
    },
    // secondary: {
    //   main: "#11cb5f",
    // },
    // error: {
    //   main: "#E64E47",
    // },
  },
});

export function App() {

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Provider store={store}>
        <ThemeProvider theme={darkTheme}>
            <Layout />
        </ThemeProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
